import { useLocation, useNavigate } from "react-router-dom";
import { useNotifications } from "./notificationHooks";
import { useCallback, useEffect, useState } from "react";

export const useGolfstatusNavigate = (fallback = "/") => {
  const goTo = useNavigate();
  const location = useLocation();

  const { clearAllNotifications } = useNotifications(false);

  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (
      !`${location?.pathname}${location.search}`?.endsWith?.(currentPath) &&
      currentPath !== ""
    ) {
      setCurrentPath("");
    }
  }, [location?.pathname, location?.search, currentPath]);

  const navigate = useCallback(
    (route = fallback, settings = {}, clearNotifications = true) => {
      if (currentPath !== route) {
        setCurrentPath(route);
        if (clearNotifications) {
          clearAllNotifications(true);
        }
        if (route === -1 && location.key === "default") {
          const route = fallback;
          goTo(route, settings);
        } else {
          goTo(route, settings);
        }
      }
    },
    [clearAllNotifications, currentPath, fallback, goTo, location.key]
  );
  return navigate;
};
